// COMMAND & CONTROL center — Incident Command Workspace, Mutual-Aid
// Interoperability and Geofencing / Operational Watch Zones (all additive).
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout, { PageHeader } from "@/components/Layout";
import { Command, Handshake, Hexagon, Search } from "lucide-react";
import { IcsEventBoard } from "@/components/command/IcsEventBoard";
import { MutualAidBoard } from "@/components/command/MutualAidBoard";
import { WatchZones } from "@/components/command/WatchZones";

const TABS = [
  ["ics", "INCIDENT COMMAND", Command, "#DC2626"],
  ["aid", "MUTUAL AID", Handshake, "#22D3EE"],
  ["zones", "WATCH ZONES", Hexagon, "#F59E0B"],
];

export default function CommandCenter() {
  const [tab, setTab] = useState("ics");
  const nav = useNavigate();
  return (
    <Layout>
      <PageHeader title="Command & Control" sub="Major-event ICS workspace · mutual-aid interoperability · operational watch zones"
        right={
          <div className="flex gap-1" data-testid="command-tabs">
            <button data-testid="command-search-all-calls" onClick={() => nav("/search-calls")}
              className="px-3 py-2 text-[11px] font-head font-bold rounded-sm flex items-center gap-1.5 transition-colors"
              style={{ border: "1px solid #0EA5E9", color: "#0EA5E9" }}>
              <Search size={13} /> SEARCH ALL CALLS
            </button>
            {TABS.map(([k, lab, Icon, color]) => (
              <button key={k} data-testid={`command-tab-${k}`} onClick={() => setTab(k)}
                className="px-3 py-2 text-[11px] font-head font-bold rounded-sm flex items-center gap-1.5 transition-colors"
                style={tab === k ? { background: color, color: "#0A0A0A" } : { border: "1px solid #2C2D35", color: "#9CA3AF" }}>
                <Icon size={13} /> {lab}
              </button>
            ))}
          </div>
        } />
      <div className="p-4 overflow-y-auto flex-1" data-testid="command-center">
        {tab === "ics" && <IcsEventBoard />}
        {tab === "aid" && <MutualAidBoard />}
        {tab === "zones" && <WatchZones />}
      </div>
    </Layout>
  );
}
